import { createSelector } from '@reduxjs/toolkit'
import { IStore } from 'redux/types'

export const selectLogout = createSelector(
	(state: IStore) => state.logout,
	(logout) => logout
)
